module.exports = __webpack_public_path__ + "assets/img/track-bottom-bg.ba1d5503.png";